import React, { Component } from 'react';
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
class DashboardFooter extends Component {
  constructor() {
    super();
    this.state = {
    };
  }


  componentDidMount() {
    var pathname = window.location.pathname;
    window.menu_selection(pathname);
  }

  render() {
    return (
      <div className="container-xxl page_background p-0">
        <Spinner/>
        <TopMenu title="Insights"/>
        <div class="container-xxl mt-5 inner_con_grey fix_scren_h">
          <div className="container inner_con ">
              <div className="row g-4 mb-2">
                <h1 className="text-start mb-3 wow fadeInUp title_view" data-wow-delay="0.1s">Coming Soon</h1>
                <p className="mb-2 mt-1 padding_left_zero">We're working hard to launch something amazing. Stay tuned!</p>
              </div>
          </div>
     </div>
    <Footer />
  </div>

    );
  }
}

export default DashboardFooter;
